import styled from 'styled-components';

const ChannelListCrewTextContainer = styled.span<React.CSSProperties>`
  display: flex;
  width: 100%;
`;

export default ChannelListCrewTextContainer;
